import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getQueryKey } from '@trpc/react-query'
import { AppShell } from '#layouts/AppShell'
import { authClient } from '#lib/auth'
import { createTrpcClient, trpc } from '#lib/trpc'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const { data } = await authClient.getSession()
    if (!data?.user) throw redirect({ to: '/login' })
    const client = createTrpcClient()
    await Promise.all([
      queryClient.ensureQueryData({
        queryKey: getQueryKey(trpc.profile.me, undefined, 'query'),
        queryFn: () => client.profile.me.query(),
      }),
      queryClient.ensureQueryData({
        queryKey: getQueryKey(trpc.profile.get, undefined, 'query'),
        queryFn: () => client.profile.get.query(),
      }),
    ])
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})
